import { render, staticRenderFns } from "./showNotificationInteractionComponent.vue?vue&type=template&id=66aaddf4&scoped=true&"
import script from "./showNotificationInteractionComponent.vue?vue&type=script&lang=js&"
export * from "./showNotificationInteractionComponent.vue?vue&type=script&lang=js&"
import style0 from "./showNotificationInteractionComponent.vue?vue&type=style&index=0&id=66aaddf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66aaddf4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardText,VCol,VRow,VTextField})
